<template>
  <b-modal 
    v-model="show" 
    size="md" 
    centered
    hide-footer
  >
  <template #modal-title>
  <div class="d-flex justify-content-center w-100">
   {{ $t('campaigns.agreementContent') }} 
  </div>
</template>

    <b-row class="border-bottom">
      <b-col class="col-12 mb-1">
        <b-form-group class="mt-2">
          <component
            :is="quill_editor"
            v-model="text_agreement"
            :options="editorOption"
            class="border-bottom-0"
            style="max-width: 100%; height: 150px"
          />
          <div id="customfields-quill-toolbar" class="d-flex justify-content-end border-top-0">
            <!-- Add a bold button -->
            <button class="ql-bold" />
            <button class="ql-italic" />
            <button class="ql-underline" />
            <button class="ql-align" />
            <button class="ql-link" />
          </div>
        </b-form-group>
        <div class="d-flex justify-content-center">
          <b-button variant="primary" small @click="addAgreementCreator()" :disabled="!text_agreement">{{$t('campaigns.saveAgreement')}}</b-button>
        </div>
      </b-col>
      <b-col class="col-12 mb-1">
        <b-dropdown
            no-flip
            :text="$t(select_text_default)"
            :class="`w-md-75 w-100 dropdownNet ${select_text_default !== 'default_select_net' ? 'p-auto' : ''}`"
            v-model="network"
            variant="outline"
            menu-class="submenu"
        >
          <template #button-content>
            <b-avatar variant="ligth" size="20" class="mr-1">
            <b-img 
              :src="getDropdownNetworks().find((item) => item.value === select_text_default.toLowerCase()).icon" 
              :class="getIconColor(select_text_default.toLowerCase(), false)"
              v-if="select_text_default !== 'default_select_net'" fluid/>
            </b-avatar>
            <span class="text-default-networks-modal">{{$t(select_text_default)}}</span>
          </template>
            <b-dropdown-item @click="dropdownItemClick(item)" v-for="item in getDropdownNetworks()" :key="item.value">
              <b-avatar variant="ligth" size="20">
                <b-img :src="item.icon" :class="getIconColor(item.network.toLowerCase(), false)" fluid/>
              </b-avatar>
              <span> {{ item.network }}</span>
            </b-dropdown-item>
        </b-dropdown>
      </b-col>

      <!-- Campo YouTube: username, query o URL del canal -->
      <b-col class="col-12 mb-1" v-if="network === 'youtube'">
        <div style="position: relative">
          <b-spinner
            v-show="yt_loading"
            variant="primary"
            label="Loading"
            small
            style="position: absolute; right: 10px; top: 10px; z-index: 1"
          />
          <b-form-input
            v-model="yt_query"
            :placeholder="$t('campaigns.youtubeChannelPlaceholder')"
            @input="handleYoutubeInput"
            @blur="yt_show_suggestions = false"
            @focus="yt_show_suggestions = yt_suggestions.length > 0"
            :state="yt_query ? (yt_channel_id ? true : (yt_no_results ? false : null)) : null"
            autocomplete="off"
            data-1p-ignore
            data-lpignore="true"
          />

          <!-- Dropdown de sugerencias -->
          <b-list-group
            v-if="yt_show_suggestions && yt_suggestions.length > 0"
            class="yt-suggestions-dropdown"
          >
            <b-list-group-item
              v-for="item in yt_suggestions"
              :key="item.channel_id"
              button
              class="d-flex align-items-center py-75"
              @mousedown.prevent="selectYtSuggestion(item)"
            >
              <b-avatar :src="item.avatar_url" size="32" />
              <div class="ml-75">
                <p class="mb-0" style="font-size: 0.875rem; font-weight: 600">{{ item.title }}</p>
                <small class="text-muted">@{{ item.username }} · {{ getFormat(item.subscribers_count) }}</small>
              </div>
            </b-list-group-item>
          </b-list-group>
        </div>

        <!-- Canal seleccionado -->
        <div v-if="yt_channel_result" class="d-flex align-items-center mt-50 p-50" style="border: 1px solid #e0e0e0; border-radius: 6px">
          <b-avatar :src="yt_channel_result.avatar_url" size="36" />
          <div class="ml-75 flex-grow-1">
            <p class="mb-0 font-weight-bold" style="font-size: 0.875rem">{{ yt_channel_result.title }}</p>
            <small class="text-muted">@{{ yt_channel_result.username }} · {{ getFormat(yt_channel_result.subscribers_count) }} subs</small>
          </div>
          <feather-icon icon="XIcon" class="cursor-pointer text-muted" @click="clearYtChannel" />
        </div>

        <!-- Sin resultados: hint de URL -->
        <div v-if="yt_no_results && !yt_channel_result" class="youtube-url-hint mt-50 p-75">
          <feather-icon icon="InfoIcon" size="14" class="mr-25 text-primary" />
          <span>{{ $t('campaigns.youtubeUrlHint') }}</span><br/>
          <small class="text-muted">
            https://www.youtube.com/channel/UC...<br/>
            https://www.youtube.com/@handle
          </small>
        </div>
      </b-col>

      <b-col class="col-12  mb-1">
        <v-select v-model="content_type" :options="options_types" value-field="value" text-field="label">
        </v-select>
      </b-col>

      <b-col class="col-12 col-lg-6 mb-1" v-if="false">
        <b-input-group class="m-auto">
          <b-input-group-prepend is-text>
            <feather-icon icon="DollarSignIcon" />
          </b-input-group-prepend>
          <input-number-comma :price="estimated_cost" identifier="number_of_interactions" @changeValue="changeValue" :placeholder="'Ingresa el costo estimado'"></input-number-comma>
        </b-input-group>
      </b-col>

      <b-col class="col-12 col-md-6 mb-1">
        <b-form-datepicker
            v-model="date_publish"
            :placeholder="$t('campaigns.date_publish')"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="es"
        />
      </b-col>
      <b-col class="col-12 col-md-6 mb-1 d-flex">
        <div class="col-12 d-flex align-items-center pr-0">
          <span class="col-6">{{content_type.label}}</span>
          <b-form-spinbutton v-model="amount_contents" min="1" max="100" class="col-6"></b-form-spinbutton>
        </div>
      </b-col>

      <b-col class="col-12 mb-1 d-flex justify-content-start" v-if="Object.keys(content_by_network).length > 0">
        <div class="col-6 d-flex align-items-center">
          <span class="text-start">{{ $t('campaigns.summaryContents') }}</span>
        </div>

        <div class="col-6 d-flex flex-column">
          <div
            v-for="(count, network) in content_by_network"
            :key="network"
            class="mb-1 d-flex align-items-center"
          >
            <b-avatar variant="light" size="20" class="mr-1">
              <b-img :src="getIconWhite(network)" :class="getIconColor(network, false)" fluid />
            </b-avatar>
            {{ networkDisplayName(network) }}: {{ count }}
          </div>
        </div>
      </b-col>


    </b-row>

    <b-row v-if="!show_form_metrics" class="d-flex justify-content-center my-2">
      <b-button
        variant="success success-button-invitations"
        class="success-button-invitations"
        @click="onSubmit()"
        :disabled="checkForm()"
      >
        {{$t('dashboard.save')}}
      </b-button>
    </b-row>

    <story
      v-if="show_form_metrics && (content_type.value === 'story' || content_type.value === 'snap')"
      :content="content_to_add"
      :uuids="{campaign_uuid, campaign_influencer}"
      :net="network"
      :info_add="{date_publish, estimated_cost}"
      @closeModal="result_form"
    />
    <video-form
      v-if="show_form_metrics && content_type.value === 'video'"
      :uuids="{campaign_uuid, campaign_influencer}"
      :content="content_to_add"
      :net="network"
      :info_add="{date_publish, estimated_cost}"
      @closeModal="result_form"
    />
    <photo-form
      v-if="show_form_metrics && content_type.value === 'photo'"
      :uuids="{campaign_uuid, campaign_influencer}"
      :content="content_to_add"
      :net="network"
      :info_add="{date_publish, estimated_cost}"
      @closeModal="result_form"
    />
    <streams-form
      v-if="show_form_metrics && content_type.value === 'streaming'"
      :uuids="{campaign_uuid, campaign_influencer}"
      :content="content_to_add"
      :net="network"
      :info_add="{date_publish, estimated_cost}"
      @closeModal="result_form"
    />
    <TVInstagram
      v-if="show_form_metrics && (content_type.value === 'instagram_tv' || content_type.value === 'reel')"
      :uuids="{campaign_uuid, campaign_influencer}"
      :content="content_to_add"
      :reel="false"
      :net="network"
      :info_add="{date_publish, estimated_cost}"
     @closeModal="result_form"
    />
    <Post
      v-if="show_form_metrics && content_type.value === 'post'"
      :uuids="{campaign_uuid, campaign_influencer}"
      :content="content_to_add"
      :net="network"
      :info_add="{date_publish, estimated_cost}"          
      @closeModal="result_form"
    />
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BImg, BDropdown, BDropdownItem, BFormDatepicker, BInputGroup, BInputGroupPrepend, BButton, BFormSpinbutton, BAvatar, BFormGroup, BFormInput, BSpinner, BListGroup, BListGroupItem
} from "bootstrap-vue";
import axios from 'axios';
import vSelect from 'vue-select';
import story from "@/views/pages/invitation/newInvitation/forms/story.vue";
import videoForm from "@/views/pages/invitation/newInvitation/forms/video.vue";
import photoForm from "@/views/pages/invitation/newInvitation/forms/photoForm.vue";
import streamsForm from "@/views/pages/invitation/newInvitation/forms/streams.vue";
import TVInstagram from "@/views/pages/invitation/newInvitation/forms/instagramTV.vue";
import Post from "@/views/pages/invitation/newInvitation/forms/post.vue";
import inputNumberComma from "@/views/components/inputs/inputNumberComma.vue";
import manage_invitation from "@/services/invitation";
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');
import service_campaign from "@/services/campaign";
import { getDropdownNetworks, getIconColor, getIconWhite } from '@/libs/utils/icons';
import { capitalize, getFormat } from '@/libs/utils/formats';
import config from '@/services/config';

export default {
  components: {
    BFormGroup,
    BModal,
    BRow,
    BCol,
    BImg,
    BDropdown,
    BDropdownItem,
    vSelect,
    BFormDatepicker,
    BInputGroup,
    BInputGroupPrepend,
    story,
    videoForm,
    photoForm,
    streamsForm,
    TVInstagram,
    Post,
    inputNumberComma,
    BButton,
    BFormSpinbutton,
    BAvatar,
    BFormInput,
    BSpinner,
    BListGroup,
    BListGroupItem,
  },
  data() {
    return {
      capitalize,
      getFormat,
      getIconWhite,
      getIconColor,
      getDropdownNetworks,
      yt_query: '',
      yt_channel_id: null,
      yt_channel_result: null,
      yt_suggestions: [],
      yt_show_suggestions: false,
      yt_no_results: false,
      yt_loading: false,
      yt_typing_timer: null,
      yt_cancel: null,
      show: false,
      network: null,
      select_text_default: 'default_select_net',
      content_type: this.$t('select_net'),
      invalid_form: true,
      type_contents : [
        {
          value: "instagram",
          types: [
            { value: "story", label: "Story" },
            { value: "photo", label: this.$t('invitation.photo') },
            { value: "reel", label: "Reel" },
            { value: "video", label: "Video" },
            { value: "streaming", label: "Live stream" },
          ],
        },
        {
          value: "youtube",
          types: [
            { value: "video", label: "Video" },
            { value: "streaming", label: "Live stream" },
            { value: "reel", label: "Short" },
          ],
        },
        {
          value: "tiktok",
          types: [
            { value: "reel", label: "TikTok" },
            { value: "story", label: "Story" },
            { value: "streaming", label: "Live stream" },
          ],
        },
        {
          value: "facebook",
          types: [
            { value: "post", label: "Post" },
            { value: "photo", label: this.$t('invitation.photo') },
            { value: "reel", label: "Reel" },
            { value: "video", label: "Video" },
            { value: "streaming", label: "Live stream" },
          ],
        },
        {
          value: "twitter",
          types: [
            { value: "post", label: "Post" },
            { value: "photo", label: this.$t('invitation.photo') },
            { value: "reel", label: "Reel" },
            { value: "video", label: "Video" },
            { value: "streaming", label: "Live stream" },
          ],
        },
        {
          value: "linkedin",
          types: [
            { value: "post", label: "Post" },
            { value: "photo", label: this.$t('invitation.photo') },
            { value: "video", label: "Video" },
            { value: "streaming", label: "Live stream" },
          ],
        },
        {
          value: "spotify",
          types: [{ value: "podcast", label: "Podcast" }],
        },
        {
          value: "twitch",
          types: [
            { value: "streaming", label: "Live stream" },
            { value: "clip", label: "Clip" }
          ],
        },
        {
          value: "pinterest",
          types: [
            { value: "photo", label: this.$t('invitation.photo') },
            { value: "video", label: "Video" },
          ],
        },
        {
          value: "blog",
          types: [{ value: "post", label: "Blog Post" }],
        },
        {
          value: "snapchat",
          types: [
            { value: "story", label: "Story" },
            { value: "reel", label: "Spotlight" },
          ],
        },
      ],
      options_types: [],
      date_publish: null,
      estimated_cost: 0,
      campaign_uuid: this.$route.params.uuid,
      content_to_add : {
        image_content: null,
        number_of_views: null,
        url_info: null,
        number_of_prints: null,
        number_of_responses: null,
        number_of_clicks_to_the_link: null,
        number_of_likes: null,
        number_of_shares: null,
        scope_number: null,
        number_of_interactions: null,
        number_of_times_saved: null,
        number_of_comments: null,
      },
      amount_contents: 1,
      text_agreement: this.agreement_with_creator || '',
      quill_editor: null,
      editorOption: {
        modules: {
          toolbar: `#customfields-quill-toolbar`
        },
        placeholder: this.$t('campaigns.writeHere')
      }
    }
  },
  props: {
    show_add_content: {
      type: Boolean,
      default: false
    },
    campaign_influencer: {
      type: String,
      required: true
    },
    show_form_metrics: {
      type: Boolean,
      default: true
    },
    content_published: {
      type: Boolean,
      default: false
    },
    agreement_with_creator: {
      type: String,
    },
    content_by_network: {
      type: Object,
      default: () => ({})
    }
  },
  created() {
    const networks = getDropdownNetworks()
    this.show = this.show_add_content
    if (localStorage.getItem('add_content_network') && localStorage.getItem('add_content_content_type') && localStorage.getItem('add_content_date_publish') && this.validJson(localStorage.getItem('add_content_content_type'))) {
      this.network = localStorage.getItem('add_content_network')
      this.select_text_default = networks.find(item => localStorage.getItem('add_content_network') === item.value).network

      const type = this.type_contents.find(item => item.value === this.network)
      this.options_types = type.types
      this.content_type = JSON.parse(localStorage.getItem('add_content_content_type'))

      this.date_publish = localStorage.getItem('add_content_date_publish')
    }
  },
  methods: {
    parseYouTubeInput(text) {
      try {
        const url = new URL(text)
        if (!url.hostname.includes('youtube.com')) return { isUrl: false }
        const channelMatch = url.pathname.match(/\/channel\/(UC[\w-]+)/)
        if (channelMatch) return { isUrl: true, value: channelMatch[1] }
        const handleMatch = url.pathname.match(/\/@([\w.-]+)/)
        if (handleMatch) return { isUrl: true, value: handleMatch[1] }
        return { isUrl: true, value: null }
      } catch {
        return { isUrl: false }
      }
    },
    handleYoutubeInput() {
      this.yt_channel_id = null
      this.yt_channel_result = null
      this.yt_suggestions = []
      this.yt_show_suggestions = false
      this.yt_no_results = false
      clearTimeout(this.yt_typing_timer)
      if (!this.yt_query) return
      this.yt_typing_timer = setTimeout(this.searchYouTubeChannel, 300)
    },
    clearYtChannel() {
      this.yt_query = ''
      this.yt_channel_id = null
      this.yt_channel_result = null
      this.yt_suggestions = []
      this.yt_show_suggestions = false
      this.yt_no_results = false
    },
    selectYtSuggestion(item) {
      this.yt_channel_id = item.channel_id
      this.yt_channel_result = item
      this.yt_query = item.username
      this.yt_suggestions = []
      this.yt_show_suggestions = false
      this.yt_no_results = false
    },
    searchYouTubeChannel() {
      const parsed = this.parseYouTubeInput(this.yt_query)

      if (parsed.isUrl) {
        // Es una URL: usar servicio de canal por channel_id/handle
        if (!parsed.value) return
        this.yt_loading = true
        const CancelToken = axios.CancelToken
        if (this.yt_cancel) this.yt_cancel()
        const self = this

        axios({
          method: 'get',
          url: `${config.urlCore}/api/v4/internal-campaigns/search-user-youtube-channel/${parsed.value}/`,
          headers: { 'Authorization': `Bearer ${localStorage.getItem('accessToken')}` },
          cancelToken: new CancelToken(c => { self.yt_cancel = c })
        })
          .then(res => {
            const channel = res.data.response
            if (channel && res.data.status === 'OK' && Object.keys(channel).length > 0) {
              const channel_id = channel.name ? channel.name.replace('channels/', '') : parsed.value
              self.yt_channel_id = channel_id
              self.yt_channel_result = {
                channel_id,
                username: (channel.channelHandle || parsed.value).replace(/^@/, ''),
                title: channel.title,
                avatar_url: channel.thumbnailUri,
                subscribers_count: parseInt(channel.subscriberCount) || 0,
              }
              self.yt_no_results = false
            } else {
              self.yt_channel_id = null
              self.yt_channel_result = null
              self.yt_no_results = true
            }
            self.yt_loading = false
          })
          .catch(error => {
            if (!axios.isCancel(error)) {
              self.yt_channel_id = null
              self.yt_channel_result = null
              self.yt_no_results = true
              self.yt_loading = false
            }
          })
      } else {
        // Es texto: usar el suggester
        this.yt_loading = true
        const CancelToken = axios.CancelToken
        if (this.yt_cancel) this.yt_cancel()
        const self = this

        axios({
          method: 'post',
          url: `${config.urlCore}/api/v1/finder/suggester/`,
          data: { query: this.yt_query.trim(), networks: 'youtube' },
          headers: { 'Authorization': `Bearer ${localStorage.getItem('accessToken')}` },
          cancelToken: new CancelToken(c => { self.yt_cancel = c })
        })
          .then(res => {
            const list = res.data.response.list || []
            if (list.length > 0) {
              self.yt_suggestions = list.map(item => ({
                channel_id: item.channel_id,
                username: (item.username || '').replace(/^@/, ''),
                title: item.title || item.full_name,
                avatar_url: item.avatar_url,
                subscribers_count: item.subscribers_count || 0,
              }))
              self.yt_show_suggestions = true
              self.yt_no_results = false
            } else {
              self.yt_suggestions = []
              self.yt_no_results = true
            }
            self.yt_loading = false
          })
          .catch(error => {
            if (!axios.isCancel(error)) {
              self.yt_suggestions = []
              self.yt_no_results = true
              self.yt_loading = false
            }
          })
      }
    },
    networkDisplayName(network) {
      const map = {
        tiktok: 'TikTok',
        youtube: 'YouTube',
        linkedin: 'LinkedIn',
      };
      return map[network] || this.capitalize(network);
    },
    addAgreementCreator() {
      console.log(this.campaign_influencer, this.text_agreement)
      service_campaign.agreementCreator(this.campaign_influencer, this.text_agreement)
        .then(() => {
          this.$emit('contentAdded')
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              props: {
                title: this.$t('campaigns.agreementAdd'),
                icon: 'CheckCircleIcon',
                text: this.$t('campaigns.agreementSuccess'),
                variant: 'success'
              }
            })
          })
        })
    },
    validJson(string) {
      try {
        JSON.parse(string);
        return true;
      } catch (error) {
        return false;
      }
    },
    checkForm() {
      if (!this.network || !this.content_type.value || !this.date_publish) return true
      if (this.network === 'youtube' && !this.yt_channel_id) return true
      return false
    },
    changeValue(new_value) {
      this.estimated_cost = new_value
    },
    dropdownItemClick(net) {
      this.select_text_default = net.network
      this.network = net.value
      const type = this.type_contents.find(item => item.value === this.network)
      this.options_types = type.types
      this.content_type = type.types[0]
      // Limpiar estado YouTube al cambiar de red
      this.yt_query = ''
      this.yt_channel_id = null
      this.yt_channel_result = null
      this.yt_suggestions = []
      this.yt_show_suggestions = false
      this.yt_no_results = false
    },
    result_form(data) {
      this.$emit('contentAdded', data)
      this.show = false
    },
    onSubmit() {
      localStorage.setItem('add_content_network', this.network)
      localStorage.setItem('add_content_date_publish', this.date_publish)
      localStorage.setItem('add_content_content_type', JSON.stringify(this.content_type))
      const form = new FormData();
      form.append("status", "content_pending");
      form.append("campaign_influencer", this.campaign_influencer)

      form.append("network", this.network);
      if (this.network === 'youtube' && this.yt_channel_id) {
        form.append("youtube_channel_id", this.yt_channel_id);
      }
      form.append("content_type", this.content_type.value);
      form.append('published_date', this.date_publish);
      form.append("estimated_cost", this.estimated_cost);
      form.append("number_repeat", this.amount_contents);

      manage_invitation.addContent(this.campaign_uuid, form).then((response) => {
        if (!response.uuid) {
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              props: {
                title: this.$t('campaigns.error'),
                icon: 'BellIcon',
                text: response.data.response.message.url_info[0],
                variant: 'danger'
              }
            })
          })
        } else if (this.content_published) {
          service_campaign.influencerAction(this.$route.params.uuid, [this.campaign_influencer], 'producing')
            .then((response) => {
              this.$emit('update_header');
              this.show = false
              this.$emit('contentAdded', response)
              loadToastificationContent().then((component) => {
                this.$toast({
                  component: component.default,
                  props: {
                    title: this.$t('campaigns.contentAdd'),
                    icon: 'CheckCircleIcon',
                    text: this.$t('campaigns.contentSuccess'),
                    variant: 'success'
                  }
                })
              })
            })
        } else {
          this.show = false
          this.$emit('contentAdded', response)
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              props: {
                title: this.$t('campaigns.contentAdd'),
                icon: 'CheckCircleIcon',
                text: this.$t('campaigns.contentSuccess'),
                variant: 'success'
              }
            })
          })
        }
      })
    },
  },
  async mounted() {
    const vue_quill_editor = (await import('vue-quill-editor'));
    this.quill_editor = vue_quill_editor.quillEditor;
    await import('quill/dist/quill.core.css');
    await import('quill/dist/quill.snow.css');
    await import('quill/dist/quill.bubble.css');
  },
  watch: {
    '$i18n.locale'() {
      this.editorOption.placeholder = this.$t('campaigns.writeHere');
    },
    agreement_with_creator(newVal) {
      this.text_agreement = newVal || ''
    }
  }
};
</script>

<style scoped>
.youtube-url-hint {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #f9f9f9;
  font-size: 0.85rem;
  line-height: 1.6;
}
.yt-suggestions-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 999;
  border: 1px solid #d8d6de;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  max-height: 220px;
  overflow-y: auto;
}
.dropdownNet{
  border: 1px solid #D8D6DE;
  border-radius: 0.3em;
}
.p-auto .btn {
  padding: 0.6em !important;
}
.dropdownNet:focus-within{
  border: none;
  border: 1px solid #7367F0;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;  
}
</style>
